import React from 'react';
import { styled } from '@mui/material/styles';
import IconCalendar from 'src/assets/images/icons/filter-calendar.svg';

export const baseInputStyles = {
  width: '100%',
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    border: '1px solid #DFDFDF',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      borderColor: '#DFDFDF',
    },
    '&.Mui-focused': {
      borderColor: '#DFDFDF',
    },
    '&.Mui-error': {
      borderColor: '#d32f2f',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiInputBase-input': {
    fontSize: '14px',
    color: '#404040',
    padding: '8px 8px 8px 12px',
    '@media (min-width: 1536px)': {
      fontSize: '16px',
    },
  },
  '& .MuiInputLabel-root': {
    fontSize: '14px',
    color: '#404040',
    backgroundColor: '#FFFFFF',
    paddingLeft: '4px',
    paddingRight: '4px',
    transform: 'translate(12px, 8px) scale(1)',
    '&.MuiInputLabel-shrink': {
      backgroundColor: '#FFFFFF',
      color: '#404040',
      transform: 'translate(12px, -9px) scale(0.75)',
    },
    '&.Mui-focused': {
      color: '#404040',
    },
    '&.Mui-error': {
      color: '#d32f2f',
    },
  },
  '& .MuiFormHelperText-root': {
    marginLeft: '4px',
    marginTop: '4px',
    fontSize: '12px',
    '&.Mui-error': {
      color: '#d32f2f',
    },
  },
};

export const EntitySelectButton = styled('button')<{ hasError?: boolean }>(({ hasError }) => ({
  width: '100%',
  minHeight: '40px',
  borderRadius: '8px',
  border: hasError ? '1px solid #d32f2f' : '1px solid #DFDFDF',
  backgroundColor: '#FFFFFF',
  color: '#404040',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 400,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 8px 8px 12px',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
  position: 'relative',
  '&:hover': {
    backgroundColor: '#FFFFFF',
    borderColor: hasError ? '#d32f2f' : '#DFDFDF',
  },
  '&:focus': {
    outline: 'none',
    borderColor: hasError ? '#d32f2f' : '#DFDFDF',
  },
}));

export const findEntityById = (entities: any[], targetId: number): any => {
  for (const entity of entities) {
    if (entity.id === targetId) {
      return entity;
    }
    if (entity.subEntities && entity.subEntities.length > 0) {
      const found = findEntityById(entity.subEntities, targetId);
      if (found) return found;
    }
  }
  return null;
};

export const CalendarIcon = () => React.createElement('img', { src: IconCalendar, alt: 'calendar', className: 'w-18 h-18' });

/**
 * Format transaction dates for display in dropdowns
 * @param selectedTransactionDates - Array of date strings in YYYY-MM format
 * @param defaultText - Text to show when no dates are selected
 * @returns Formatted display text
 */
export const formatTransactionDateDisplayText = (selectedTransactionDates: string[], defaultText: string = 'Transaction Date'): string => {
  if (selectedTransactionDates.length === 0) {
    return defaultText;
  }

  return selectedTransactionDates
    .map((dateStr: string) => {
      // Only format if the date string is in YYYY-MM format
      const yearMonthRegex = /^\d{4}-\d{2}$/;
      if (!yearMonthRegex.test(dateStr)) {
        return dateStr; // Return as-is if not in YYYY-MM format
      }

      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
      });
    })
    .join(', ');
};
